import AuthService from "./AuthService.js";
import LoginCtrl from "./LoginCtrl.js";
import ProfileCtrl from "./ProfileCtrl.js";

export default angular.module("antes.auth", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("login",{
    views:{  
      "login": {
        url: "/login",
        template: require("./login.html"),
        controller: "LoginCtrl",
        controllerAs: "ctrl",
      }
    }
  })
  .state("profile",{
    url: "/profil",
    template: require("./profile.html"),
    controller: ProfileCtrl,
    controllerAs: "ctrl",
    resolve: ProfileCtrl.$resolve
  })
})
.service("AuthService", AuthService)
.controller("LoginCtrl", LoginCtrl)
.run(function($rootScope, $transitions, AuthService, $interval){
  $rootScope.auth = AuthService;
  $transitions.onStart({}, function (trans) {
    var $state = trans.router.stateService;
    if(trans.to().name !== "login"){
      if(!AuthService.isLoggedIn){
        AuthService.nextState = trans.targetState();
        return $state.target("login");
      }
    }
  });
  $interval(() => AuthService.keepalive(), 5*60*1000);
})
.name


// WEBPACK FOOTER //
// ./src/auth/index.js